module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-52c3bbe56d0a54a55f9ed4533c97c3f6.png";